import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function KakaoCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URL(window.location.href).searchParams.get('code');
    if (!code) {
      sessionStorage.setItem('kakaoDuplicate', 'true');
      navigate('/register');
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL || 'https://campus-life-production.up.railway.app';

    fetch(`${apiUrl}/api/auth/kakao?code=${code}`)
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok && data.isDuplicate) {
          sessionStorage.setItem('kakaoDuplicate', 'true');
          navigate('/register');
          return;
        }
        if (!ok) {
          // 중복 아닌 오류는 그냥 다시 인증 화면으로
          alert('카카오 인증 중 오류가 발생했습니다. 다시 시도해주세요.');
          navigate('/register');
          return;
        }
        sessionStorage.setItem('kakaoVerified', 'true');
        sessionStorage.setItem('kakaoName', data.name || '');
        sessionStorage.setItem('kakaoId', data.kakaoId || '');
        navigate('/register');
      })
      .catch(() => {
        alert('카카오 인증 중 오류가 발생했습니다.');
        navigate('/register');
      });
  }, [navigate]);

  return (
    <div style={containerStyle}>
      <p style={textStyle}>카카오 인증 처리 중...</p>
    </div>
  );
}

const containerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' };
const textStyle = { fontSize: '18px', color: '#666' };

export default KakaoCallback;